import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.reviewgrid .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.reviewgrid .swiper-button-next',
      prevEl: '.reviewgrid .swiper-button-prev',
    },
    pagination: {
      el: '.reviewgrid .swiper-pagination',
      clickable: true,
    },
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
});
